import { get } from 'lodash';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { mapState, mapGetters } from 'vuex';
import 'swiper/css';
import formCheckbox from '@/components/market/market-detail-charts/checkbox/checkbox.vue';
import { readableLineColor } from '@/utils/chart-theme';
import { uuidv4 } from '@/utils/helpers';

export default {
  components: {
    formCheckbox,
    swiper: Swiper,
    swiperSlide: SwiperSlide,
  },
  props: {
    contracts: {
      type: Array,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      canScrollLeft: false,
      canScrollRight: false,
      swiperInstance: null,
      swiperOption: {
        slidesPerView: 'auto',
        freeMode: true,
        watchOverflow: true,
        spaceBetween: 10,
        roundLengths: true,
      },
    };
  },
  computed: {
    ...mapState('market', ['chartType']),
    ...mapState('app', ['resolvedTheme']),
    ...mapGetters('app', ['isLayoutDesktop']),
    showImage() {
      return get(this.chartOptions, 'showContractImagesOnLegend', false);
    },
  },
  methods: {
    onSwiperReady(swiperInstance) {
      this.swiperInstance = swiperInstance;
      this.updateNavigationState(swiperInstance);
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          swiperInstance.update();
          this.updateNavigationState(swiperInstance);
        });
      });
    },
    onTransitionEnd(swiperInstance) {
      this.updateNavigationState(swiperInstance);
    },
    onTouchEnd(swiperInstance) {
      this.updateNavigationState(swiperInstance);
    },
    onReachBeginning() {
      this.canScrollLeft = false;
    },
    onReachEnd() {
      this.canScrollRight = false;
    },
    updateNavigationState(swiperInst) {
      const inst = swiperInst || this.swiperInstance;
      if (inst) {
        this.canScrollLeft = !inst.isBeginning;
        this.canScrollRight = !inst.isEnd;
      }
    },
    scrollLeft() {
      this.swiperInstance.slidePrev();
    },
    scrollRight() {
      this.swiperInstance.slideNext();
    },
    contractName(item) {
      const regionUUID = get(this.chartOptions, 'regionUUID', null);
      if (regionUUID !== null) {
        return `checkbox-${regionUUID}-${item.contractName}-${item.marketId}${uuidv4()}`;
      }
      return `checkbox-${item.contractName}-${item.marketId}${uuidv4()}`;
    },
    imageStyleModifiers(item) {
      return {
        'border-color': readableLineColor(item.lineColor, this.resolvedTheme),
        'background-image': `url(${item.contractImageSmallUrl})`,
      };
    },
    onChange(item, checked) {
      this.$emit('toggleItem', item, checked);
    },
    checkboxColor(item) {
      const color = item.additional ? item.additionalLineColor : item.lineColor;
      return readableLineColor(color, this.resolvedTheme);
    },
  },
};
